import type { ActionType } from '@rc-component/trigger/lib/interface';
import { Popover } from 'antd';
import { Fragment, Suspense } from 'react';
import { selectOpenSubMenu } from '../../../../modules/ui/store/ui-slice';
import { useAppSelector } from '../../../../store/hooks';
import useMenuItems, { MenuItem } from '../../hooks/use-menu-items';
import UseNavigateHeaderLinks from '../../hooks/use-navigate-header-links';
import MainMenuIcon from '../main-menu-icon/main-menu-icon';
import SubMenu from '../submenu/submenu';
import { getLabelStyles } from '../utils/utils';
import styles from './main-menu-desktop.module.css';

const MainMenuDesktop = (): JSX.Element => {
  const openSubMenu = useAppSelector(selectOpenSubMenu);
  const [menuItems, activeMenuItem] = useMenuItems();
  const navigateHeaderLinks = UseNavigateHeaderLinks();

  const getPopoverProps = ({ subMenuContent }: MenuItem) => {
    if (subMenuContent) {
      return {
        content: (
          <Suspense>
            <SubMenu contentType="hover" openSubmenu={true} submenuContent={subMenuContent} />
          </Suspense>
        ),
        trigger: openSubMenu ? ('none' as ActionType) : ('hover' as ActionType),
      };
    }
    return {
      trigger: 'none' as ActionType,
    };
  };

  return (
    <>
      {menuItems?.map(item => (
        <Fragment key={item.key}>
          <Popover placement="rightTop" {...getPopoverProps(item)}>
            <div className={styles.menuItem} onClick={() => navigateHeaderLinks(item)}>
              <span className={styles.menuIcon}>
                <MainMenuIcon menuItemIcon={item.icon} />
              </span>
              <p className={getLabelStyles(item, activeMenuItem)}>{item.label}</p>
            </div>
          </Popover>
        </Fragment>
      ))}
    </>
  );
};

export default MainMenuDesktop;
